module.exports = __webpack_public_path__ + "static/shopify-bc87c023ebceea6e68e9f5e5a1e905d6.png";